import { gql } from 'graphql-request'

export const UPDATE_SHELF = gql`
  mutation UpdateShelf($updateShelfInput: UpdateShelfInput!) {
    updateShelf(updateShelfInput: $updateShelfInput) {
      id
    }
  }
`
